import { useState, useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import "./LoadingScreen.scss";
import Logo from "../../assets/logos/RentlyBuzzLogo.webp";

export default function LoadingScreen({
  onLoadComplete,
  assetsLoaded = false,
}) {
  const loadingRef = useRef(null);
  const logoRef = useRef(null);
  const progressRef = useRef(null);

  const [progress, setProgress] = useState(0);
  const [timeComplete, setTimeComplete] = useState(false);

  useGSAP(() => {
    const isMobile = window.innerWidth <= 768;

    // Animate logo entrance
    gsap.fromTo(
      logoRef.current,
      {
        scale: 0.5,
        opacity: 0,
        rotation: -180,
      },
      {
        scale: 1,
        opacity: 1,
        rotation: 0,
        duration: isMobile ? 0.8 : 1.5,
        ease: "back.out(1.7)",
      }
    );

    // Progress bar animation - instant if assets loaded, otherwise normal timer
    const progressTween = gsap.to(progressRef.current, {
      width: "100%",
      duration: assetsLoaded ? 0.5 : 13, // Instant fill if assets loaded
      ease: assetsLoaded ? "power2.out" : "none",
      onUpdate: function () {
        const currentProgress = this.progress() * 100;
        setProgress(currentProgress);
      },
      onComplete: () => {
        setTimeComplete(true);
      },
    });

    return () => {
      progressTween.kill();
    };
  }, [assetsLoaded]);

  // Complete loading when progress reaches 100%
  useGSAP(() => {
   
    if (timeComplete) {
      const isMobile = window.innerWidth <= 768;

      setTimeout(
        () => {
          gsap.to(loadingRef.current, {
            y: "-100%",
            duration: isMobile ? 0.5 : 1,
            ease: "power2.inOut",
            onComplete: () => {
              onLoadComplete();
            },
          });
        },
        isMobile ? 250 : 500
      );
    }
  }, [timeComplete, onLoadComplete]);

  return (
    <div className="loading-screen" ref={loadingRef}>
      <div className="loading-content">
        <div className="logo-container" ref={logoRef}>
          <img src={Logo} alt="RentlyBuzz Logo" className="loading-logo" />
        </div>
      </div>
      <div className="loading-progress-bar">
        <div
          className="loading-progress-bar__fill"
          ref={progressRef}
          style={{ width: "0%" }}
        />
      </div>
    </div>
  );
}
